import styled from 'styled-components';
const variants = {
    xl: {
        fontFamily: 'Cosmica, sans-serif',
        fontSize: '56px',
        lineHeight: '1.143em',
        htmlElement: 'h1',
    },
    lg: {
        fontFamily: 'Cosmica, sans-serif',
        fontSize: '48px',
        lineHeight: '1.167em',
        htmlElement: 'h2',
    },
    md: {
        fontFamily: 'Cosmica, sans-serif',
        fontSize: '32px',
        lineHeight: '1.125em',
        htmlElement: 'h3',
    },
    sm: {
        fontFamily: 'Cosmica, sans-serif',
        fontSize: '24px',
        lineHeight: '1.333em',
        htmlElement: 'h4',
    },
    xs: {
        fontFamily: 'Cosmica, sans-serif',
        fontSize: '20px',
        lineHeight: '1.4em',
        htmlElement: 'h5',
    },
};
export const Header = styled.h1.attrs(({ size }) => {
    var _a;
    if (!size) {
        size = 'xs';
    }
    return {
        as: (_a = variants[size]) === null || _a === void 0 ? void 0 : _a.htmlElement,
        size,
    };
}).withConfig({ displayName: "brc-sc-Header", componentId: "brc-sc-1wvlsd3" }) `
  font-family: ${({ size }) => { var _a, _b; return (_b = (_a = variants[size]) === null || _a === void 0 ? void 0 : _a.fontFamily) !== null && _b !== void 0 ? _b : variants.md.fontFamily; }};
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  color: ${({ theme }) => theme.navNeutralDark};
  font-size: ${({ size }) => { var _a, _b; return (_b = (_a = variants[size]) === null || _a === void 0 ? void 0 : _a.fontSize) !== null && _b !== void 0 ? _b : variants.md.fontSize; }};
  line-height: ${({ size }) => { var _a, _b; return (_b = (_a = variants[size]) === null || _a === void 0 ? void 0 : _a.lineHeight) !== null && _b !== void 0 ? _b : variants.md.lineHeight; }};
  font-weight: bold;
`;
Header.displayName = 'Header';
//# sourceMappingURL=header.js.map